module.exports = __webpack_public_path__ + "media/open-close.79ddc26f.mp3";